<template>
    <div>
        <v-card>
            <v-card-title>
                <v-icon left color="primary">settings</v-icon>
                Configurações SIC
            </v-card-title>

            <v-tabs v-model="tab">
                <v-tab v-if="this.userPlanoFundoSic || this.userMaster ">Plano de Fundo</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <!-- TAB 1 -->
                <v-tab-item>
                    <v-card flat>
                        <imgfundo ></imgfundo>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Imgfundo from '../components/sic/Imgfundo.vue';

export default {
    components: { Imgfundo },
    data: function () {
        return {
            tab: 0,
            dialog: null,
            dialogLoading: false,
        }
    },
    computed: {
        ...mapGetters(['userMaster', 'userPlanoFundoSic']),
    }
}
</script>